
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1iee7_di2un_141",
  "announcer": "awsui_announcer_1iee7_di2un_149"
};
  